import React from 'react';
import PropTypes from 'prop-types';
import { getPriceString } from 'site-modules/shared/utils/price-utils';
import { LoadingDots } from 'site-modules/shared/components/loading-dots/loading-dots';

export function TaxRebateText({ taxRebateAmount = null }) {
  if (taxRebateAmount === null) {
    // null is the default value, meaning the api call was not yet made vs API would return 0 if there is no rebate
    return <LoadingDots />;
  }
  const taxRebateText = taxRebateAmount ? `Up to ${getPriceString(taxRebateAmount)}` : 'Not available';
  return <span>{taxRebateText}</span>;
}
TaxRebateText.propTypes = {
  taxRebateAmount: PropTypes.number,
};
